<template>
  <div>
    <RecordNotFound v-if="status_code == 404" :message="status_message"></RecordNotFound>
    <div v-else-if="is_no_records == 1">
      <GlobalEmptyRecord RouteName="AmcServiceCreate">
        <template slot="title">
          <h2>Business starts with Good Products</h2>
        </template>
        <template slot="content">
          <span style="color: gray">Find Products for Customers</span>
        </template>
        <template slot="page">New Product Bundle</template>
      </GlobalEmptyRecord>
    </div>

    <div class="start-page" v-else style="margin-top: -10px !important">
      <template v-if="CheckedCount == 0">
        <b-row class="px-pad border-bottom" style="height: 42px">
          <b-col md="6" lg="6" sm="6" cols="6" class="px-0">
            <!-- custom filter dropdown -->
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              class="index-filter-heading"
              size="sm"
              dropdown
              :text="filter_name"
            >
              <div class="dropdownitem-list">
                <b-dropdown-item
                  :class="{ filter_dropdown: true }"
                  :to="{
                  name: 'AmcService',
                  query: {
                    page: 1,
                    show: 10,
                    search: '',
                    status: status,
                    sort: sort,
                    label: label,
                    status: item.status_id,
                  },
                }"
                  v-for="item in filter_list"
                  :key="item.status_id"
                  v-if="item.status_name != filter_name"
                >{{ item.status_name }}</b-dropdown-item>
              </div>
            </b-dropdown>
            <!-- edit button for custom filter dropdown -->
          </b-col>
          <b-col md="6" lg="6" sm="6" cols="6" class="text-right px-0">
            <router-link
              :to="{ name : 'AmcServiceCreate'}"
              v-if="RoutePermission(false,'','invoice','amcservice','create')"
            >
              <b-button variant="primary" size="sm">New Product Bundle</b-button>
            </router-link>
            <b-button variant="light" size="sm" class="ml-2 mr-2" @click="getrefreshList()">
              <i class="la la-refresh la-lg"></i>
            </b-button>
            <b-dropdown variant="light" size="sm" class="no-caret-dropdown pl-2">
              <template slot="button-content">
                <i class="la la-navicon la-lg"></i>
              </template>
              <p class="fw-semi-bold theme-text-color ml-3">Add Columns</p>
              <div class="dropdownitem-block">
                <li class="ml-3">
                  <b-form-checkbox name="pdt_unit" v-model="pdt_unit" value="1">Unit</b-form-checkbox>
                </li>
                <!-- <li class="ml-3 pt-2">
                <b-form-checkbox
                  name="pdt_intra_tax_id"
                  v-model="pdt_intra_tax_id"
                  value="2"
                  >GST percent</b-form-checkbox
                >
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox
                  name="pdt_inter_tax_id"
                  v-model="pdt_inter_tax_id"
                  value="3"
                  >IGST percent</b-form-checkbox
                >
                </li>-->

                <li class="ml-3 pt-2">
                  <b-form-checkbox name="sales_account" v-model="sales_account" value="5">Account</b-form-checkbox>
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox name="pdt_desc" v-model="pdt_desc" value="8">Description</b-form-checkbox>
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox name="created_at" v-model="created_at" value="9">Created Time</b-form-checkbox>
                </li>
                <li class="ml-3 pt-2 pb-2">
                  <b-form-checkbox name="updated_at" v-model="updated_at" value="10">Updated Time</b-form-checkbox>
                </li>
              </div>
            </b-dropdown>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col cols="12" class="px-0">
          <!--  row for bulk delete option and acitve and inactive if atleast one checkbox is selected in the table -->
          <b-row style="height: 42px" class="px-pad border-bottom" v-if="CheckedCount > 0">
            <b-col xl="6" lg="6" md="6" sm="6" xs="6" cols="6" class="px-pad">
              <b-button
                size="sm"
                v-b-modal.pdtdelete
                @click="modalPage = 'delete'"
                variant="light"
                class="text-left"
                :disabled="
                !RoutePermission(false, '', '', 'amcservice', 'delete')
              "
              >
                <i
                  class="glyphicon glyphicon-trash"
                  v-b-tooltip="
                  !RoutePermission(false, '', 'invoice', 'amcservice', 'delete')
                    ? ' You do not have permission to perform this operation. Please contact your Administrator. '
                    : ''
                "
                ></i>
              </b-button>
              <b-button
                size="sm"
                @click="(statusPage = 'active'), (modalPage = 'status')"
                v-b-modal.statusPage
                variant="light"
                class="text-left ml-2"
                :disabled="
                !RoutePermission(false, '', '', 'amcservice', 'update')
              "
              >
                <span
                  v-b-tooltip="
                  !RoutePermission(false, '', 'invoice', 'amcservice', 'update')
                    ? ' You do not have permission to perform this operation. Please contact your Administrator. '
                    : ''
                "
                >Active</span>
              </b-button>
              <b-button
                size="sm"
                @click="(statusPage = 'inactive'), (modalPage = 'status')"
                v-b-modal.statusPage
                variant="light"
                class="text-left ml-2"
                :disabled="
                !RoutePermission(false, '', '', 'amcservice', 'update')
              "
              >
                <span
                  v-b-tooltip="
                  !RoutePermission(false, '', 'invoice', 'amcservice', 'update')
                    ? ' You do not have permission to perform this operation. Please contact your Administrator. '
                    : ''
                "
                >Inactive</span>
              </b-button>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="6" xs="6" cols="6" class="px-pad">
              <i
                v-on:click="
                checkAll({
                  target: {
                    checked: false,
                  },
                }),
                  (CheckedCount = 0),
                  (checkboxes1[0] = false)
              "
                class="la la-times-circle-o la-lg cursor_pointer float-right mar-top-close"
              ></i>
            </b-col>
          </b-row>
          <b-alert
            class="alert-transparent alert-shade mx-mar mt-3"
            :show="this.$route.params.search == '' ? false : true"
          >
            <router-link
              class="text-dark float-right"
              :to="{
              name: 'AmcService',
              query: {
                page: page,
                show: count,
                search: '',
                sort: sort,
                label: label,
                custom: custom,
              },
            }"
            >
              <i class="la la-remove la-lg text-decoration-none"></i>
            </router-link>
            <p>
              <span class="fw-semi-bold">Product Name / HSN / SAC code :</span>
              {{ this.$route.query.search }}
            </p>
          </b-alert>

          <div
            :class="
            this.$route.params.search == ''
              ? 'table-responsive'
              : 'table_search'
          "
            id="scrollCol"
          >
            <table class="table table-hover index-table">
              <thead>
                <tr>
                  <th style="width: 54px !important">
                    <div class="abc-checkbox index-checkbox text-left">
                      <input
                        type="checkbox"
                        id="checkboxall"
                        v-model="checkboxes1[0]"
                        @change="(event) => checkAll(event)"
                      />
                      <label for="checkboxall" />
                    </div>
                  </th>
                  <th style="min-width: 200px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                      name: 'AmcService',
                      query: {
                        page: page,
                        show: show,
                        search: search_criteria,
                        status: status,
                        sort: sort == 'asc' ? 'desc' : 'asc',
                        label: 'pdt_name',
                        custom: custom,
                      },
                    }"
                    >
                      Name
                      <small class="text-muted" v-if="label == 'pdt_code'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight: thinner"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width: 180px !important">SKU</th>
                  <th style="min-width: 150px !important">HSN</th>

                  <th style="min-width: 150px !important" v-if="pdt_unit">Unit</th>
                  <th style="min-width: 150px !important" v-if="sales_account">Account</th>
                  <th style="min-width: 150px !important" v-if="pdt_desc">Description</th>
                  <!-- <th style="min-width:150px !important" v-if="pdt_intra_tax_id">GST percent</th>
                  <th style="min-width:150px !important" v-if="pdt_inter_tax_id">IGST Percent</th>-->
                  <th style="min-width: 150px !important" class="text-right">Sale Price</th>
                  <th style="min-width: 300px !important" v-if="created_at">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                      name: 'AmcService',
                      query: {
                        page: page,
                        show: show,
                        search: search_criteria,
                        status: status,
                        sort: sort == 'asc' ? 'desc' : 'asc',
                        label: 'created_at',
                        custom: custom,
                      },
                    }"
                    >
                      Created Time
                      <small class="text-muted" v-if="label == 'created_at'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight: thinner"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width: 300px !important" v-if="updated_at">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                      name: 'AmcService',
                      query: {
                        page: page,
                        show: show,
                        search: search_criteria,
                        status: status,
                        sort: sort == 'asc' ? 'desc' : 'asc',
                        label: 'updated_at',
                        custom: custom,
                      },
                    }"
                    >
                      Updated Time
                      <small class="text-muted" v-if="label == 'updated_at'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight: thinner"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width: 30px !important" class="text-right"></th>
                </tr>
              </thead>
              <tbody>
                <template v-if="lists.length == 0">
                  <tr>
                    <td colspan="7" class="text-center">No data to display</td>
                  </tr>
                </template>
                <template v-else>
                  <template v-for="(list, index) in lists">
                    <tr :key="list.id" v-b-toggle="'pdt_collapse' + index">
                      <td>
                        <div class="abc-checkbox index-checkbox text-left">
                          <input
                            type="checkbox"
                            v-model="checkboxes1[index + 1]"
                            :id="'checkbox' + (index + 1)"
                            :true-value="list.pdt_grp.product_id"
                            :value="list.pdt_grp.product_id"
                            @change="
                            (event) =>
                              changeCheck(event, 'checkboxes1', index + 1)
                          "
                          />
                          <label :for="'checkbox' + (index + 1)" />
                        </div>
                      </td>
                      <td style="max-width: 200px !important; cursor: pointer">
                        <span class="text">
                          <i
                            :style="list.hide == 1 ? { display: 'none' } : ''"
                            v-on:click.once="
                            (list.hide = 1), (list.pdt_grp.collapse = true)
                          "
                            class="fi flaticon-layers"
                          ></i>
                          <i
                            :style="list.hide == 1 ? '' : { display: 'none' }"
                            @click="
                            list.pdt_grp.collapse = !list.pdt_grp.collapse
                          "
                            class="fi flaticon-layers"
                          ></i>

                          <router-link
                            v-if="
                            RoutePermission(true, 'AmcServiceView', '', '', '')
                          "
                            class="event-link ml-3 theme-text-color"
                            :to="{
                            name: 'AmcServiceView',
                            params: { id: list.pdt_grp.product_id },
                          }"
                          >
                            <span class="theme-text-color">
                              {{
                              list.pdt_grp.pdt_name +
                              " - (" +
                              list.pdt_list.length +
                              " products)"
                              }}
                            </span>
                          </router-link>
                          <span v-else class="text theme-text-color">
                            {{
                            list.pdt_grp.pdt_name +
                            " - (" +
                            list.pdt_list.length +
                            " products)"
                            }}
                          </span>
                        </span>
                      </td>
                      <td style="width: 180px !important">
                        <span class="text">{{ list.pdt_grp.pdt_sku }}</span>
                      </td>
                      <td>{{ list.pdt_grp.pdt_hsn }}</td>

                      <td v-if="pdt_unit">
                        <span class="text">{{ list.pdt_grp.unit_name }}</span>
                      </td>
                      <td v-if="sales_account">{{ list.pdt_grp.gl_acc_name }}</td>
                      <td style="width: 150px !important" v-if="pdt_desc">
                        <span class="text">{{ list.pdt_grp.pdt_desc }}</span>
                      </td>

                      <td class="text-right">
                        {{
                        orgCurrencySymbol +
                        " " +
                        parseFloat(
                        list.pdt_grp.selling_price
                        ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                        })
                        }}
                      </td>
                      <td v-if="created_at">
                        <span class="text">{{ displayDateTime(list.pdt_grp.created_at) }}</span>
                      </td>
                      <td v-if="updated_at">
                        <span class="text">{{ displayDateTime(list.pdt_grp.updated_at) }}</span>
                      </td>
                      <td class="text-right">
                        <router-link
                          v-if="
                          RoutePermission(true, 'AmcServiceUpdate', '', '', '')
                        "
                          class="event-link theme-text-color text-decoration-none"
                          :to="{
                          name: 'AmcServiceUpdate',
                          params: { id: list.pdt_grp.product_id },
                          query:{page_from:'index'}
                        }"
                        >
                          <i class="la la-edit la-lg theme-text-color table-hover-visible"></i>
                        </router-link>
                      </td>
                    </tr>
                    <tr
                      v-for="item in list.pdt_list"
                      :key="item.id"
                      v-show="list.pdt_grp.collapse == 1 ? true : false"
                    >
                      <td style="width: 1% !important"></td>
                      <td
                        style="
                        border-left: 0.5px dotted #b5b2b2;
                        width: 200px !important;
                      "
                        v-if="RoutePermission(true, 'ProductView', '', '', '')"
                      >
                        <router-link
                          class="event-link theme-text-color"
                          :to="{
                          name: 'ProductView',
                          params: { id: item.pdt_id },
                        }"
                        >
                          <span class="word-break">{{ item.pdt_name }}</span>
                        </router-link>
                      </td>
                      <td v-else style="width: 200px !important">
                        <span class="word-break">{{ item.pdt_name }}</span>
                      </td>
                      <td style="width: 180px !important">
                        <span class="word-break">{{ item.pdt_sku }}</span>
                      </td>
                      <td style="width: 150px !important">{{ item.pdt_hsn }}</td>

                      <td style="width: 150px !important" v-if="pdt_unit"></td>
                      <td style="width: 150px !important" v-if="sales_account"></td>
                      <td style="width: 150px !important" v-if="pdt_desc"></td>
                      <td class="text-right" style="width: 150px !important"></td>
                      <td style="width: 150px !important" v-if="created_at"></td>
                      <td style="width: 150px !important" v-if="updated_at"></td>
                      <td></td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="lists.length > 0"
        style="width: 100%; position: absolute; border-top: 1px solid #e0e0e0"
        class="px-pad"
      >
        <b-col xl="5" md="6" lg="6" sm="8" cols="6" class="mt-2 pt-1 px-0">
          <nav class="float-left">
            <p>
              Showing {{ total_count != 0 ? (page - 1) * count + 1 : 0 }} to
              {{ (page - 1) * show + lists.length }} of {{ total_count }} entries
              <span>
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  size="xs"
                  :text="count"
                  left
                >
                  <router-link
                    :to="{
                    name: 'AmcService',
                    query: {
                      page: 1,
                      show: 10,
                      search: search_criteria,
                      status: status,
                      sort: sort,
                      label: label,
                      custom: custom,
                    },
                  }"
                    class="text-decoration-none"
                  >
                    <b-dropdown-item-button class="page-link" v-if="count != 10">10</b-dropdown-item-button>
                  </router-link>
                  <router-link
                    :to="{
                    name: 'AmcService',
                    query: {
                      page: 1,
                      show: 25,
                      search: search_criteria,
                      status: status,
                      sort: sort,
                      label: label,
                      custom: custom,
                    },
                  }"
                    class="text-decoration-none"
                  >
                    <b-dropdown-item-button class="page-link" v-if="count != 25">25</b-dropdown-item-button>
                  </router-link>
                  <router-link
                    :to="{
                    name: 'AmcService',
                    query: {
                      page: 1,
                      show: 50,
                      search: search_criteria,
                      status: status,
                      sort: sort,
                      label: label,
                      custom: custom,
                    },
                  }"
                    class="text-decoration-none"
                  >
                    <b-dropdown-item-button class="page-link" v-if="count != 50">50</b-dropdown-item-button>
                  </router-link>
                </b-dropdown>
              </span>
              rows per page
            </p>
          </nav>
        </b-col>
        <b-col
          xl="2"
          md="2"
          lg="2"
          sm="4"
          cols="4"
          style="text-align: center"
          class="mt-2 pt-1 px-0"
        >
          <div v-if="arrow">
            <a @click="left('#scrollCol')" class="mr-2">
              <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>

              <!-- <b-badge class="badge" variant="light">&lt;</b-badge> -->
            </a>
            <a @click="right('#scrollCol')">
              <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>

              <!-- <b-badge class="badge" variant="light">&gt;</b-badge> -->
            </a>
          </div>
        </b-col>
        <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
          <template v-if="total_count > show">
            <nav class="float-right">
              <ul class="pagination">
                <li class="page-item">
                  <template v-if="page != 1">
                    <router-link
                      class="page-link"
                      :to="{
                      name: 'AmcService',
                      query: {
                        page: page - 1,
                        show: count,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    >
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </router-link>
                  </template>
                  <template v-else>
                    <a class="page-link" href="#" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </a>
                  </template>
                </li>
                <li class="page-item">
                  <router-link
                    class="page-link"
                    :to="{
                    name: 'AmcService',
                    query: {
                      page: 1,
                      show: count,
                      search: search_criteria,
                      status: status,
                      sort: sort,
                      label: label,
                      custom: custom,
                    },
                  }"
                  >First</router-link>
                </li>
                <li class="page-item">
                  <template v-if="page != 1">
                    <router-link
                      class="page-link"
                      :to="{
                      name: 'AmcService',
                      query: {
                        page: page - 1,
                        show: count,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    >Previous</router-link>
                  </template>
                  <template v-else>
                    <a href="#" class="page-link">Previous</a>
                  </template>
                </li>
                <li class="page-item">
                  <template v-if="total_count > page * count">
                    <router-link
                      class="page-link"
                      :to="{
                      name: 'AmcService',
                      query: {
                        page: page + 1,
                        show: count,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    >Next</router-link>
                  </template>
                  <template v-else>
                    <a href="#" class="page-link">Next</a>
                  </template>
                </li>
                <li class="page-item">
                  <router-link
                    class="page-link"
                    :to="{
                    name: 'AmcService',
                    query: {
                      page: Math.ceil(total_count / count),
                      show: count,
                      search: search_criteria,
                      status: status,
                      sort: sort,
                      label: label,
                      custom: custom,
                    },
                  }"
                  >Last</router-link>
                </li>
                <li class="page-item">
                  <template v-if="total_count > page * count">
                    <router-link
                      class="page-link"
                      :to="{
                      name: 'AmcService',
                      query: {
                        page: page + 1,
                        show: count,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    >
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </router-link>
                  </template>
                  <template v-else>
                    <a class="page-link" href="#" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </a>
                  </template>
                </li>
              </ul>
            </nav>
          </template>
        </b-col>
      </b-row>
      <b-modal
        id="pdtdelete"
        body-class="bg-white"
        cancel-title="Cancel"
        cancel-variant="light"
        :ok-title-html="submitted == true ? loaderIcon + 'Yes' : 'Yes'"
        title="Bulk Delete"
        @ok="handledelete"
        :ok-disabled="submitted"
      >
        <p>Are you sure you want to delete this products ?</p>
      </b-modal>
      <LogRecord :message="logrecords"></LogRecord>
      <b-modal
        id="statusPage"
        body-class="bg-white"
        cancel-title="Cancel"
        cancel-variant="light"
        :ok-title-html="submitted == true ? loaderIcon + 'Yes' : 'Yes'"
        title="Status"
        @ok="handledelete"
        :ok-disabled="submitted"
      >
        <p>Are you sure you want to {{ statusPage }} the selected product Bundles ?</p>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification";
import $ from "jquery";
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll
import { formatDate } from "@/mixins/formatDate"; // to formatdate in y-m-d
import downloadexcel from "vue-json-excel"; // to excel export the output
import LogRecord from "@/components/Modal/ErrorList"; // modal for deleting created credit used record
import RecordNotFound from "@/pages/Error/RecordNotFound";
function getPageProducts(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const search = routeTo.query.search || "";
  const status =
    routeTo.query.status || store.state.amcservice.index_status || "";
  const label = routeTo.query.label || "";
  const sort = routeTo.query.sort || "";
  const custom = routeTo.query.custom || "";

  store
    .dispatch("amcservice/fetchLists", {
      page: currentPage,
      show: show,
      search: search,
      status: status,
      sort: sort,
      label: label,
      custom: custom
    })
    .then(response => {
      if (search != "" && response.status == 201) {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: response.data.status,
          type: "danger",
          showCloseButton: true
        });
      }
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.search = search;
      routeTo.params.status = status;
      routeTo.params.label = label;
      routeTo.params.sort = sort;
      routeTo.params.custom = custom;
      next();
    });
}
export default {
  mixins: [notificationMixin, scrollTable, formatDate],
  props: {
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    },
    search: [String, Number],
    status: [String, Number],
    label: [String, Number],
    sort: [String, Number],
    custom: [String, Number]
  },
  name: "Product",
  components: {
    downloadexcel,
    LogRecord,
    RecordNotFound
  },
  data() {
    return {
      logrecords: "", // to show log of popup funcitons
      arrow: false,
      pdt_unit: "",
      sales_account: "",
      pdt_desc: "",
      export_xl: {
        Id: "composite_id",
        Code: "composite_code",
        "Legacy Id": "pdt_legacy_id",
        "Composite Name": "composite_name",
        "Sale Price": "pdt_sal_price",
        "Sales Description": "sales_desc",
        "Product TYPE": "pdt_type",
        "Product UNIT": "pdt_unit",
        "Product HSN": "pdt_hsn",
        "Product SKU": "pdt_sku",
        "Product UPC": "pdt_upc",
        "Product EAN": "pdt_ean",
        "Product ISBN": "pdt_isbn",
        "Product MPN": "pdt_mpn",
        "Reorder Level": "reorder_level",
        "Opening Stock": "opening_stock",
        "Opening Stock Value": "opening_stock_value",
        "Product Status": "pdt_status",
        "Sales Account": "sales_account",
        "Product Weight": "pdt_weight",
        "Product Length": "pdt_length",
        "Product Width": "pdt_width",
        "Product Height": "pdt_height",
        "Intra Tax": "pdt_intra_tax_id",
        "Inter Tax": "pdt_inter_tax_id",
        Taxable: "tax_preference",
        Exemption: "exempt_reason",
        "Track Account": "inv_account",
        "Mapped Product": "mapped_product",
        "Mapped Quantity": "mapped_quantity",
        "Created Time": "created_at",
        "Updated Time": "updated_at"
      },
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      pdt_unit: "",
      created_at: "",
      updated_at: "",
      pdt_intra_tax_id: "",
      pdt_inter_tax_id: "",
      modalPage: "",
      statusPage: "",
      CheckedCount: 0,
      CheckedPdtIds: [],
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      checkboxes1: [],
      showDismissibleAlert: this.$route.query.search == "" ? false : true,
      total: 10,
      check_index: [],
      submitted: false
    };
  },
  updated() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  methods: {
    //refresh List
    getrefreshList() {
      var page = this.page;
      var page_show = this.show;
      const currentPage = page;
      const show = page_show;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const update = this.$route.query.update;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const custom = this.$route.query.custom || "";
      const update_status = update == true ? false : true;
      store
        .dispatch("amcservice/fetchLists", {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          custom: custom
        })
        // .then(() => {
        //   this.$router.push({
        //     name: this.$route.name,
        //     query: {
        //       page: currentPage,
        //       show: show,
        //       search: search,
        //       status: status,
        //       sort: sort,
        //       label: label,
        //       update: update_status
        //     }
        //   });
        // });
        .then(async () => {
          this.page = await (this.lists.length == 0 && this.page != 1
            ? (this.page = 1)
            : this.page);
          this.show = show;
          this.status = status;
          this.label = label;
          this.$route.params.sort = sort;
          await this.$router.push({
            query: {
              page: this.page,
              show: this.show,
              search: search,
              status: this.status,
              sort: sort,
              label: this.label
            }
          });
        });
    },

    startDownload() {
      this.loader = "Loading...";
    },
    finishDownload() {
      this.loader = "Downloaded";
    },
    getPresentValue(arr, prop, val) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i]["filter_id"];
          break;
        }
      }
      return hasMatch;
    },
    handledelete() {
      this.submitted = true;
      var pdt_ids = this.checkboxes1;
      pdt_ids = pdt_ids.filter(item => item !== false && item !== true);
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const sort = this.$route.query.sort || "";
      const label = this.$route.query.label || "";
      var data, url;
      if (this.modalPage == "delete") {
        url = "pdtdelete";
        data = JSON.stringify({
          del_status: pdt_ids
        });
      } else if (this.modalPage == "status") {
        url = "pdtstatus";
        data = JSON.stringify({
          name: this.statusPage,
          status: pdt_ids
        });
      }

      store.dispatch("amcservice/" + url, data).then(response => {
        this.submitted = false;
        this.CheckedCount = 0;
        this.checkboxes1 = [];
        // if (this.modalPage != "delete") {
        //   window.Messenger().post({
        //     extraClasses:
        //       "messenger-fixed messenger-on-top messenger-on-center",
        //     message: this.delete,
        //     type: "success",
        //     showCloseButton: true
        //   });
        // }
        store
          .dispatch("amcservice/fetchLists", {
            page: currentPage,
            show: show,
            search: search,
            status: status,
            sort: sort,
            label: label
          })
          .then(() => {
            this.$route.params.page = currentPage;
            this.$route.params.show = show;
            this.$route.params.search = search;
            this.$route.params.status = status;
            this.$route.params.sort = sort;
            this.$route.params.label = label;
          })
          .then(async () => {
            this.page = await (this.lists.length == 0 && this.page != 1
              ? (this.page = 1)
              : this.page);
            this.show = show;
            this.status = status;
            this.label = label;
            this.$route.params.sort = sort;
            await this.$router.push({
              query: {
                page: this.page,
                show: this.show,
                search: search,
                status: this.status,
                sort: sort,
                label: this.label
              }
            });
          });
        // if (this.modalPage == "delete") {
        //   this.logrecords =
        //     this.message.message.length == 0
        //       ? this.message.success
        //       : this.message.message;
        //   this.$root.$emit("bv::show::modal", "loglist");
        // }
        if (this.status_code == 200) {
          this.logrecords =
            this.message.message.length == 0
              ? this.message.success
              : this.message.message;
          this.$root.$emit("bv::show::modal", "loglist");
        } else {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: response.data.message,
            type: response.data.type,
            showCloseButton: true
          });
        }
      });
    },
    checkAll(ev) {
      this.check_index = [];
      var fields = this;
      fields.lists.map(function(value, index) {
        fields.checkboxes1[index + 1] =
          ev.target.checked == true ? value.pdt_grp.product_id : false;
      });

      this.CheckedCount =
        ev.target.checked == true
          ? (this.page - 1) * this.show + this.lists.length
          : 0;
    },
    //select the checkbox//
    changeCheck(ev, checkbox, id) {
      var pdt_ids = this.checkboxes1;
      pdt_ids = pdt_ids.filter(item => item !== false);
      // check all if page length matches
      if (pdt_ids.length == this.lists.length) {
        this[checkbox][0] = true;
      }
      // uncheck if any of the checkbox is unchecked
      if (!ev.target.checked) {
        this[checkbox][0] = false;
      }
      if (this[checkbox][id] != false) {
        this.CheckedCount = parseInt(this.CheckedCount) + 1;
      } else {
        this.CheckedCount = parseInt(this.CheckedCount) - 1;
      }
    }
  },
  created() {
    var check = [false];
    var i;
    for (i = 0; i < this.total; i++) {
      check.push(false);
    }
    this.checkboxes1 = check;
    this.CheckedCount = 0;
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch("products/fetchProductDetails");
    getPageProducts(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    store.state.amcservice.index_status = "";
    getPageProducts(routeTo, next);
    this.CheckedCount = 0;
    this.checkboxes1 = [];
    this.check_index = [];
  },
  beforeRouteLeave(to, from, next) {
    store.state.amcservice.bundle_index_history = from.fullPath;
    store.state.amcservice.index_status = from.params.status;
    next();
  },

  computed: {
    ...mapState({
      status_code: state => state.amcservice.status_code,
      status_message: state => state.amcservice.status_message,
      status_type: state => state.amcservice.status_type,
      lists: state => state.amcservice.lists,
      total_count: state => state.amcservice.total_count,
      count: state => state.amcservice.count,
      search_criteria: state => state.amcservice.search_criteria,
      filter_list: state => state.amcservice.filter_list,
      filter_name: state => state.amcservice.filter_name,
      delete: state => state.amcservice.delete,
      export: state => state.amcservice.export,
      message: state => state.amcservice.log_details,
      is_no_records: state => state.amcservice.is_no_records // to check for an record in the database
    }),
    ...mapGetters(["orgCurrencySymbol"])
  }
};
</script>